module.exports = __webpack_public_path__ + "static/media/shack-setup.72cba1e5.png";